import React from 'react';
import {Field} from "formik";
import {makeStyles} from "@material-ui/core";
import Textfield from "../../components/formikcomponent/TextField";
const useStyles = makeStyles(() => ({inputItem: { width: "100%" }}));
const Veevacontent = (props) => {
const classes = useStyles();
return(
  <Field
    name={props.name}
    type="text"
    component={Textfield}
    variant="filled"
    className={classes.inputItem}
    label={props.label}
    InputProps={props.InputProps}
  />
);
};
export default Veevacontent;
